module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ Border ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-border-width"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-border-color"
    }
  }), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n        ใช้กำหนดสีของ Border\n      ")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-border-radius"
    }
  }), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n        ใช้กำหนดรัศมีของ Border\n      ")]), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBackground'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("   Background\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBoxPosition'
      }
    }
  }, [_vm._v("\n            Box Position   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-border"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Border\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-128px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-border-width"
    }
  }, [_vm._v("Border Width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-border-color"
    }
  }, [_vm._v("Border Color")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-border-radius"
    }
  }, [_vm._v("Border Radius")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-border-width"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Border Width\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n        ใช้กำหนดความหนาของ Border โดย Biomatic จะใช้ Default\n        "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-style")]), _vm._v(" เป็น\n        "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("solid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -primary _fs-6 _mgbt-64px"
  }, [_c('p', [_c('strong', [_vm._v("คำแนะนำ")]), _vm._v(" – ตอนนี้ Biomatic ยังไม่มี Class ที่ใช้กำหนด Border Style เป็นแบบอื่น\n          เพราะ Border Style อื่น นอกจาก solid มักไม่ค่อยมีการใช้งาน\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdlw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-left-width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdrw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-right-width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdtw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-top-width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdbtw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-bottom-width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdvw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-top-width")]), _vm._v(" และ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-bottom-width")]), _vm._v(" "), _c('small', {
    staticClass: "_opct-50"
  }, [_vm._v("(Vertical)")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdhw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-left-width")]), _vm._v(" และ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-right-width")]), _vm._v(" "), _c('small', {
    staticClass: "_opct-50"
  }, [_vm._v("(Horizontal)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdw-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdlw-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdrw-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdtw-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdbtw-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdvw-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdhw-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Pixel Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("12px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("24px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("48px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("64px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("128px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("256px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("512px")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Border Width")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Border Width-->\n<div class=\"_bdw-4px\"></div>\n<div class=\"_bdw-8px\"></div>\n<div class=\"_bdw-16px\"></div>\n\n<!-- Border Left Width -->\n<div class=\"_bdlw-4px\"></div>\n<div class=\"_bdlw-8px\"></div>\n<div class=\"_bdlw-16px\"></div>\n\n<!-- Border Right Width -->\n<div class=\"_bdrw-4px\"></div>\n<div class=\"_bdrw-8px\"></div>\n<div class=\"_bdrw-16px\"></div>\n\n<!-- Border Top Width -->\n<div class=\"_bdtw-4px\"></div>\n<div class=\"_bdtw-8px\"></div>\n<div class=\"_bdtw-16px\"></div>\n\n<!-- Border Bottom Width -->\n<div class=\"_bdbtw-4px\"></div>\n<div class=\"_bdbtw-8px\"></div>\n<div class=\"_bdbtw-16px\"></div>\n\n<!-- Border Vertical Width -->\n<div class=\"_bdvw-4px\"></div>\n<div class=\"_bdvw-8px\"></div>\n<div class=\"_bdvw-16px\"></div>\n\n<!-- Border Left Width with Breakpoint -->\n<div class=\"_bdlw-0px _bdlw-32px-sm\"></div>\n<div class=\"_bdlw-0px _bdlw-32px-md\"></div>\n<div class=\"_bdlw-0px _bdlw-32px-lg\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdw-4px _mgbt-8px"
  }, [_vm._v("_bdw-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdw-8px _mgbt-8px"
  }, [_vm._v("_bdw-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdw-16px _mgbt-32px"
  }, [_vm._v("_bdw-16px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdlw-4px _mgbt-8px"
  }, [_vm._v("_bdlw-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdlw-8px _mgbt-8px"
  }, [_vm._v("_bdlw-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdlw-16px _mgbt-32px"
  }, [_vm._v("_bdlw-16px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdrw-4px _mgbt-8px"
  }, [_vm._v("_bdrw-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdrw-8px _mgbt-8px"
  }, [_vm._v("_bdrw-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdrw-16px _mgbt-32px"
  }, [_vm._v("_bdrw-16px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdtw-4px _mgbt-8px"
  }, [_vm._v("_bdtw-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdtw-8px _mgbt-8px"
  }, [_vm._v("_bdtw-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdtw-16px _mgbt-32px"
  }, [_vm._v("_bdtw-16px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdbtw-4px _mgbt-8px"
  }, [_vm._v("_bdbtw-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdbtw-8px _mgbt-8px"
  }, [_vm._v("_bdbtw-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdbtw-16px _mgbt-32px"
  }, [_vm._v("_bdbtw-16px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdvw-4px _mgbt-8px"
  }, [_vm._v("_bdvw-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdvw-8px _mgbt-8px"
  }, [_vm._v("_bdvw-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdvw-16px _mgbt-32px"
  }, [_vm._v("_bdvw-16px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdhw-4px _mgbt-8px"
  }, [_vm._v("_bdhw-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdhw-8px _mgbt-8px"
  }, [_vm._v("_bdhw-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdhw-16px _mgbt-32px"
  }, [_vm._v("_bdhw-16px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdlw-0px _bdlw-32px-sm _mgbt-8px"
  }, [_vm._v("_bdlw-0px _bdlw-32px-sm")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdlw-0px _bdlw-32px-md _mgbt-8px"
  }, [_vm._v("_bdlw-0px _bdlw-32px-md")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdlw-0px _bdlw-32px-lg _mgbt-8px"
  }, [_vm._v("_bdlw-0px _bdlw-32px-lg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-border-color"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Border Color\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdcl-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-color")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdcl-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Biomatic's Color Name Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("primary")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("accent")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("neutral")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("positive")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("negative")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("warning")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("white")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("gray")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("dark")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("black")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-hover")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Border Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Border Color -->\n<div class=\"_bdw-2px _bdcl-primary\"></div>\n<div class=\"_bdw-2px _bdcl-accent\"></div>\n<div class=\"_bdw-2px _bdcl-positive\"></div>\n<div class=\"_bdw-2px _bdcl-negative\"></div>\n<div class=\"_bdw-2px _bdcl-warning\"></div>\n<div class=\"_bdw-2px _bdcl-info\"></div>\n\n<!-- Gray Scale Border Color -->\n<div class=\"_bdw-2px _bdcl-white\"></div>\n<div class=\"_bdw-2px _bdcl-gray\"></div>\n<div class=\"_bdw-2px _bdcl-dark\"></div>\n<div class=\"_bdw-2px _bdcl-black\"></div>\n\n<!-- Primary Border Color with Ligthness Modifier -->\n<div class=\"_bdw-2px _bdcl-primary-900\"></div>\n<div class=\"_bdw-2px _bdcl-primary-800\"></div>\n<div class=\"_bdw-2px _bdcl-primary-700\"></div>\n<div class=\"_bdw-2px _bdcl-primary-600\"></div>\n<div class=\"_bdw-2px _bdcl-primary-500\"></div>\n<div class=\"_bdw-2px _bdcl-primary-400\"></div>\n<div class=\"_bdw-2px _bdcl-primary-300\"></div>\n<div class=\"_bdw-2px _bdcl-primary-200\"></div>\n<div class=\"_bdw-2px _bdcl-primary-100\"></div>\n\n<!-- Accent Border Color with Ligthness Modifier -->\n<div class=\"_bdw-2px _bdcl-accent-900\"></div>\n<div class=\"_bdw-2px _bdcl-accent-800\"></div>\n<div class=\"_bdw-2px _bdcl-accent-700\"></div>\n<div class=\"_bdw-2px _bdcl-accent-600\"></div>\n<div class=\"_bdw-2px _bdcl-accent-500\"></div>\n<div class=\"_bdw-2px _bdcl-accent-400\"></div>\n<div class=\"_bdw-2px _bdcl-accent-300\"></div>\n<div class=\"_bdw-2px _bdcl-accent-200\"></div>\n<div class=\"_bdw-2px _bdcl-accent-100\"></div>\n\n<!-- Neutral Border Color with Ligthness Modifier -->\n<div class=\"_bdw-2px _bdcl-neutral-900\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-800\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-700\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-600\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-500\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-400\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-300\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-200\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-100\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary _mgbt-8px"
  }, [_vm._v("_bdcl-primary")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent _mgbt-8px"
  }, [_vm._v("_bdcl-accent")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-positive _mgbt-8px"
  }, [_vm._v("_bdcl-positive")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-negative _mgbt-8px"
  }, [_vm._v("_bdcl-negative")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-warning _mgbt-8px"
  }, [_vm._v("_bdcl-warning")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-info _mgbt-32px"
  }, [_vm._v("_bdcl-info")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-white _mgbt-8px"
  }, [_vm._v("_bdcl-white")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-gray _mgbt-8px"
  }, [_vm._v("_bdcl-gray")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-dark _mgbt-8px"
  }, [_vm._v("_bdcl-dark")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-black _mgbt-32px"
  }, [_vm._v("_bdcl-black")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-900 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-900")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-800 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-800")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-700 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-700")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-600 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-600")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-500 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-500")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-400 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-400")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-300 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-300")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-200 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-200")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-100 _mgbt-32px"
  }, [_vm._v("_bdcl-primary-100")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-900 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-900")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-800 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-800")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-700 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-700")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-600 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-600")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-500 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-500")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-400 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-400")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-300 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-300")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-200 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-200")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-100 _mgbt-32px"
  }, [_vm._v("_bdcl-accent-100")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-900 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-900")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-800 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-800")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-700 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-700")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-600 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-600")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-500 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-500")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-400")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-300 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-300")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-200 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-200")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-100"
  }, [_vm._v("_bdcl-neutral-100")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Border Color และ hover")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Border Color -->\n<div class=\"_bdw-2px _bdcl-primary\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary _bdcl-negative-hover _mgbt-8px"
  }, [_vm._v("\n          _bdcl-primary _bdcl-negative-hover\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-border-radius"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Border Radius\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdrd-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-radius")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdtlrd-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-top-left-radius")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdtrrd-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-top-right-radius")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdbtlrd-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-bottom-left-radius")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdbtrrd-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-bottom-right-radius")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdrd-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdtlrd-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdtrrd-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdbtlrd-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdbtrrd-*")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-16px"
  }, [_c('strong', [_vm._v("Pixel Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("12px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("24px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("48px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("64px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("128px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("256px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("512px")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px"
  }, [_c('strong', [_vm._v("Percentage Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("50pct")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Biomatic's Color Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("max")]), _vm._v(" (9999px)\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Border Width")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Border Radius -->\n<div class=\"_bdw-2px _bdrd-2px\"></div>\n<div class=\"_bdw-2px _bdrd-4px\"></div>\n<div class=\"_bdw-2px _bdrd-8px\"></div>\n<div class=\"_bdw-2px _bdrd-max\"></div>\n<div class=\"_bdw-2px _bdrd-50pct\"></div>\n\n<div class=\"_bdw-2px _bdtrrd-2px\"></div>\n<div class=\"_bdw-2px _bdtrrd-4px\"></div>\n<div class=\"_bdw-2px _bdtrrd-8px\"></div>\n<div class=\"_bdw-2px _bdtrrd-max\"></div>\n<div class=\"_bdw-2px _bdtrrd-50pct\"></div>\n\n<div class=\"_bdw-2px _bdtrrd-2px _bdbtrrd-2px\"></div>\n<div class=\"_bdw-2px _bdtrrd-4px _bdbtrrd-4px\"></div>\n<div class=\"_bdw-2px _bdtrrd-8px _bdbtrrd-8px\"></div>\n<div class=\"_bdw-2px _bdtrrd-max _bdbtrrd-max\"></div>\n<div class=\"_bdw-2px _bdtrrd-50pct _bdbtrrd-50pct\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdrd-2px _mgbt-8px"
  }, [_vm._v("._bdrd-2px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdrd-4px _mgbt-8px"
  }, [_vm._v("._bdrd-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdrd-8px _mgbt-8px"
  }, [_vm._v("._bdrd-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdrd-max _mgbt-8px"
  }, [_vm._v("._bdrd-max")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdrd-50pct _mgbt-32px"
  }, [_vm._v("._bdrd-50pct")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-2px _mgbt-8px"
  }, [_vm._v("._bdtrrd-2px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-4px _mgbt-8px"
  }, [_vm._v("._bdtrrd-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-8px _mgbt-8px"
  }, [_vm._v("._bdtrrd-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-max _mgbt-8px"
  }, [_vm._v("._bdtrrd-max")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-50pct _mgbt-32px"
  }, [_vm._v("._bdtrrd-50pct")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-2px _bdbtrrd-2px _mgbt-8px"
  }, [_vm._v("._bdtrrd-2px ._bdbtrrd-2px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-4px _bdbtrrd-4px _mgbt-8px"
  }, [_vm._v("._bdtrrd-4px ._bdbtrrd-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-8px _bdbtrrd-8px _mgbt-8px"
  }, [_vm._v("._bdtrrd-8px ._bdbtrrd-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-max _bdbtrrd-max _mgbt-8px"
  }, [_vm._v("._bdtrrd-max ._bdbtrrd-max")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-50pct _bdbtrrd-50pct"
  }, [_vm._v("._bdtrrd-50pct ._bdbtrrd-50pct")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-490593e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/AtomicBorder.vue
// module id = 126
// module chunks = 0